module.exports = __webpack_public_path__ + "static/Background-ecd8a96ec70eb817fee797749999fb7f.png";